import React, { useEffect } from 'react'
import { useForm,useFieldArray } from 'react-hook-form'
import { useDispatch, useSelector } from 'react-redux'
import { get_province_rules, update_province_rule } from '../../redux/actions/rulesAction'
// import { updateProvinceRule } from './your-redux-slice' // Uncomment this

const EditRule = ({ closeModals, formData }) => {
    const dispatch = useDispatch()
    // Initialize React Hook Form
    const { isSuccess } = useSelector(state=> state.province_rule)
    const { 
    register, 
    handleSubmit, 
    reset, 
    formState: { errors },
    control
} = useForm({
    defaultValues: {
        ...formData,
        basic_forms: formData?.basic_forms?.map(item => ({ value: item })) || [],
        advanced_legal_forms: formData?.advanced_legal_forms?.map(item => ({ value: item })) || []
    }
})    

const { fields, append, remove } = useFieldArray({
    control,
    name: "stages"
})

const { 
    fields: basic_forms_fields, 
    append: append_basic, 
    remove: remove_basic 
} = useFieldArray({
    control,
    name: 'basic_forms'
})

const { 
    fields: advanced_legal_form_fields, 
    append: append_advanced, 
    remove: remove_advanced 
} = useFieldArray({
    control,
    name: 'advanced_legal_forms'
})

const onSubmit = (data) => {
    const finalData = {
        ...data,
        basic_forms: data.basic_forms.map(item => item.value),
        advanced_legal_forms: data.advanced_legal_forms.map(item => item.value)
    }
    
    try {
        dispatch(update_province_rule(finalData))
        if(isSuccess){
         dispatch(get_province_rules())
         closeModals()
    }
    } catch (error) {
        console.log('the error', error)
    }
}


useEffect(() => {
    if (formData) {
        reset({
            ...formData,
            basic_forms: formData.basic_forms?.map(item => ({ value: item })) || [],
            advanced_legal_forms: formData.advanced_legal_forms?.map(item => ({ value: item })) || []
        })
    }
}, [formData, reset])

return (
    <>
        <div className="modal fade show d-block" tabIndex="-1" style={{zIndex:"9999"}}  role="dialog">
            <div className="modal-dialog modal-xl modal-dialog-scrollable">
                <div className="modal-content">
                    <div className="modal-header bg-warning text-dark">
                        <h5 className="modal-title">Edit Rules: {formData['province.name']}</h5>
                        <button type="button" className="btn-close" onClick={closeModals}></button>
                    </div>
                    
                    <div className="modal-body">
                        <form id="edit-rule-form" onSubmit={handleSubmit(onSubmit)}>
                            
                            <h6 className="border-bottom pb-2 mb-3">Basic Information</h6>
                            <div className="row g-3 mb-4">
                                <div className="col-md-4">
                                    <label className="form-label">Reg Body Name</label>
                                    <input 
                                        type="text" 
                                        className="form-control" 
                                        {...register("regulatory_body_name")} 
                                    />
                                </div>
                                <div className="col-md-2">
                                    <label className="form-label">Acronym</label>
                                    <input 
                                        type="text" 
                                        className="form-control" 
                                        {...register("regulatory_body_acronym")} 
                                    />
                                </div>
                                <div className="col-md-6">
                                    <label className="form-label">Key Legislation</label>
                                    <input 
                                        type="text" 
                                        className="form-control" 
                                        {...register("key_legislation")} 
                                    />
                                </div>
                            </div>

                            <h6 className="border-bottom pb-2 mb-3">Rent Increase Rules</h6>
                            <div className="row g-3 mb-4">
                                <div className="col-md-3">
                                    <label className="form-label">Notice Days</label>
                                    <input 
                                        type="number" 
                                        className="form-control" 
                                        {...register("rent_increase_notice_days", { valueAsNumber: true })} 
                                    />
                                </div>
                                <div className="col-md-3">
                                    <label className="form-label">Cap %</label>
                                    <input 
                                        type="number" 
                                        step="0.1"
                                        className="form-control" 
                                        {...register("rent_increase_cap_percentage", { valueAsNumber: true })} 
                                    />
                                </div>
                                <div className="col-md-3">
                                    <label className="form-label">Frequency (Days)</label>
                                    <input 
                                        type="number" 
                                        className="form-control" 
                                        {...register("rent_increase_frequency_days", { valueAsNumber: true })} 
                                    />
                                </div>
                                <div className="col-md-3">
                                    <div className="form-check mt-4">
                                        <input 
                                            className="form-check-input" 
                                            type="checkbox" 
                                            id="agiCheck"
                                            {...register("has_above_guideline_process")} 
                                        />
                                        <label className="form-check-label" htmlFor="agiCheck">Has AGI Process</label>
                                    </div>
                                </div>
                            </div>

                            <h6 className="border-bottom pb-2 mb-3">Non-Payment & Eviction</h6>
                            <div className="row g-3 mb-4">
                                <div className="col-md-3">
                                    <label className="form-label">Notice Days</label>
                                    <input 
                                        type="number" 
                                        className="form-control" 
                                        {...register("non_payment_notice_days", { valueAsNumber: true })} 
                                    />
                                </div>
                                <div className="col-md-3">
                                    <label className="form-label">Remedy Days</label>
                                    <input 
                                        type="number" 
                                        className="form-control" 
                                        {...register("non_payment_remedy_days", { valueAsNumber: true })} 
                                    />
                                </div>
                                <div className="col-md-3">
                                    <label className="form-label">Filing Fee ($)</label>
                                    <input 
                                        type="number" 
                                        className="form-control" 
                                        {...register("eviction_filing_fee", { valueAsNumber: true })} 
                                    />
                                </div>
                                <div className="col-md-3">
                                    <label className="form-label">App Form Code</label>
                                    <input 
                                        type="text" 
                                        className="form-control" 
                                        {...register("eviction_application_form_code")} 
                                    />
                                </div>
                            </div>

                            <h6 className="border-bottom pb-2 mb-3">Landlord Use & Termination</h6>
                            <div className="row g-3 mb-4">
                                <div className="col-md-3">
                                    <label className="form-label">LL Notice Days</label>
                                    <input 
                                        type="number" 
                                        className="form-control" 
                                        {...register("landlord_use_notice_days", { valueAsNumber: true })} 
                                    />
                                </div>
                                <div className="col-md-3">
                                    <label className="form-label">Compensation (Months)</label>
                                    <input 
                                        type="number" 
                                        className="form-control" 
                                        {...register("landlord_use_compensation_months", { valueAsNumber: true })} 
                                    />
                                </div>
                                <div className="col-md-3">
                                    <label className="form-label">Tenant Term. Days</label>
                                    <input 
                                        type="number" 
                                        className="form-control" 
                                        {...register("tenant_termination_notice_days", { valueAsNumber: true })} 
                                    />
                                </div>
                                <div className="col-md-3">
                                    <label className="form-label">LL Form Code</label>
                                    <input 
                                        type="text" 
                                        className="form-control" 
                                        {...register("landlord_use_form_code")} 
                                    />
                                </div>
                            </div>

                            <h6 className="border-bottom pb-2 mb-3">Settings & Booleans</h6>
                            <div className="row g-3 mb-5">
                                <div className="col-md-3">
                                    <div className="form-check">
                                        <input 
                                            className="form-check-input" 
                                            type="checkbox" 
                                            id="stdLease"
                                            {...register("has_standard_lease_form")} 
                                        />
                                        <label className="form-check-label" htmlFor="stdLease">Standard Lease</label>
                                    </div>
                                </div>
                                <div className="col-md-3">
                                    <div className="form-check">
                                        <input 
                                            className="form-check-input" 
                                            type="checkbox" 
                                            id="manLease"
                                            {...register("lease_form_mandatory")} 
                                        />
                                        <label className="form-check-label" htmlFor="manLease">Mandatory Lease</label>
                                    </div>
                                </div>
                                <div className="col-md-3">
                                    <div className="form-check">
                                        <input 
                                            className="form-check-input" 
                                            type="checkbox" 
                                            id="eService"
                                            {...register("allows_electronic_service")} 
                                        />
                                        <label className="form-check-label" htmlFor="eService">Allow E-Service</label>
                                    </div>
                                </div>
                                <div className="col-md-3">
                                    <div className="form-check">
                                        <input 
                                            className="form-check-input" 
                                            type="checkbox" 
                                            id="regMail"
                                            {...register("requires_registered_mail")} 
                                        />
                                        <label className="form-check-label" htmlFor="regMail">Req. Reg. Mail</label>
                                    </div>
                                </div>
                                <div className="col-md-3">
                                    <div className="form-check">
                                        <input 
                                            className="form-check-input" 
                                            type="checkbox" 
                                            id="personSvc"
                                            {...register("allows_in_person_service")} 
                                        />
                                        <label className="form-check-label" htmlFor="personSvc">Allow In-Person</label>
                                    </div>
                                </div>
                                <div className="col-md-3">
                                    <div className="form-check">
                                        <input 
                                            className="form-check-input" 
                                            type="checkbox" 
                                            id="proofSvc"
                                            {...register("requires_proof_of_service")} 
                                        />
                                        <label className="form-check-label" htmlFor="proofSvc">Req. Proof of Svc</label>
                                    </div>
                                </div>
                                <div className="col-md-3">
                                    <div className="form-check">
                                        <input 
                                            className="form-check-input" 
                                            type="checkbox" 
                                            id="onlinePortal"
                                            {...register("has_online_dispute_portal")} 
                                        />
                                        <label className="form-check-label" htmlFor="onlinePortal">Online Portal</label>
                                    </div>
                                </div>
                            </div>
                            
                            <div className="row g-3 mb-4">
                                <div className="col-md-6">
                                    <div className="card">
                                        <div className="card-header d-flex justify-content-between align-items-center">
                                            <h6 className="mb-0">Basic Forms</h6>
                                            <button
                                                type='button'
                                                className="btn btn-sm btn-success" 
                                                onClick={() => append_basic({ value: "" })}
                                            >
                                                <i className="bi bi-plus"></i> Add
                                            </button>
                                        </div>
                                        <div className="card-body bg-light">
                                            {basic_forms_fields.map((field, index) => (
                                                <div key={field.id} className="d-flex mb-2">
                                                    <input 
                                                        type="text" 
                                                        className="form-control me-2" 
                                                        {...register(`basic_forms.${index}.value`)} 
                                                    />
                                                    <button 
                                                        type="button" 
                                                        className="btn btn-sm btn-outline-danger"
                                                        onClick={() => remove_basic(index)}
                                                    >
                                                        <i className="bi bi-trash"></i>
                                                    </button>
                                                </div>
                                            ))}
                                            {basic_forms_fields.length === 0 && <p className="text-center text-muted small">No basic forms added.</p>}
                                        </div>
                                    </div>
                                </div>

                                <div className="col-md-6">
                                    <div className="card">
                                        <div className="card-header d-flex justify-content-between align-items-center">
                                            <h6 className="mb-0">Advanced Legal Forms</h6>
                                            <button
                                                type='button'
                                                className="btn btn-sm btn-success" 
                                                onClick={() => append_advanced({ value: "" })}
                                            >
                                                <i className="bi bi-plus"></i> Add
                                            </button>
                                        </div>
                                        <div className="card-body bg-light">
                                            {advanced_legal_form_fields.map((field, index) => (
                                                <div key={field.id} className="d-flex mb-2">
                                                    <input 
                                                        type="text" 
                                                        className="form-control me-2" 
                                                        {...register(`advanced_legal_forms.${index}.value`)} 
                                                    />
                                                    <button 
                                                        type="button" 
                                                        className="btn btn-sm btn-outline-danger"
                                                        onClick={() => remove_advanced(index)}
                                                    >
                                                        <i className="bi bi-trash"></i>
                                                    </button>
                                                </div>
                                            ))}
                                            {advanced_legal_form_fields.length === 0 && <p className="text-center text-muted small">No advanced forms added.</p>}
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <h6 className="border-bottom pb-2 mb-3 d-flex justify-content-between align-items-center mt-5">
                                <span>Stages</span>
                                <button 
                                    type="button" 
                                    className="btn btn-sm btn-success"
                                    onClick={() => append({
                                        stage: "",
                                        action: {
                                            form: "",
                                            type: "send_notice",
                                            auto_send: false,
                                            notify_tenant: false,
                                            notify_landlord: false,
                                            application_variant: ""
                                        },
                                        trigger: {
                                            type: "days_after_due",
                                            value: 0,
                                            result_code: 0
                                        }
                                    })}
                                >
                                    <i className="bi bi-plus"></i> Add Stage
                                </button>
                            </h6>

                            <div className="mb-4">
                                {fields.map((field, index) => (
                                    <div key={field.id} className="card mb-3 bg-light">
                                        <div className="card-body">
                                            <div className="d-flex justify-content-between mb-3">
                                                <h6 className="card-title text-primary">Stage {index + 1}</h6>
                                                <button 
                                                    type="button" 
                                                    className="btn btn-sm btn-outline-danger"
                                                    onClick={() => remove(index)}
                                                >
                                                    Remove
                                                </button>
                                            </div>

                                            <div className="row g-3 mb-3">
                                                <div className="col-md-12">
                                                    <label className="form-label fw-bold">Stage Name</label>
                                                    <input 
                                                        type="text" 
                                                        className="form-control" 
                                                        {...register(`stages.${index}.stage`)} 
                                                    />
                                                </div>
                                            </div>

                                            <hr />
                                            <h6 className="fw-bold small text-muted">Action Details</h6>
                                            <div className="row g-3 mb-3">
                                                <div className="col-md-4">
                                                    <label className="form-label">Action Type</label>
                                                    <input 
                                                        type="text" 
                                                        className="form-control form-control-sm"
                                                        {...register(`stages.${index}.action.type`)} 
                                                    />
                                                </div>
                                                <div className="col-md-4">
                                                    <label className="form-label">Form</label>
                                                    <input 
                                                        type="text" 
                                                        className="form-control form-control-sm"
                                                        {...register(`stages.${index}.action.form`)} 
                                                    />
                                                </div>
                                                <div className="col-md-4">
                                                    <label className="form-label">Variant</label>
                                                    <input 
                                                        type="text" 
                                                        className="form-control form-control-sm"
                                                        {...register(`stages.${index}.action.application_variant`)} 
                                                    />
                                                </div>
                                            </div>

                                            <div className="row g-3 mb-3">
                                                <div className="col-md-3">
                                                    <div className="form-check">
                                                        <input 
                                                            className="form-check-input" 
                                                            type="checkbox" 
                                                            id={`auto-${index}`}
                                                            {...register(`stages.${index}.action.auto_send`)} 
                                                        />
                                                        <label className="form-check-label small" htmlFor={`auto-${index}`}>Auto Send</label>
                                                    </div>
                                                </div>
                                                <div className="col-md-3">
                                                    <div className="form-check">
                                                        <input 
                                                            className="form-check-input" 
                                                            type="checkbox" 
                                                            id={`notifyT-${index}`}
                                                            {...register(`stages.${index}.action.notify_tenant`)} 
                                                        />
                                                        <label className="form-check-label small" htmlFor={`notifyT-${index}`}>Notify Tenant</label>
                                                    </div>
                                                </div>
                                                <div className="col-md-3">
                                                    <div className="form-check">
                                                        <input 
                                                            className="form-check-input" 
                                                            type="checkbox" 
                                                            id={`notifyL-${index}`}
                                                            {...register(`stages.${index}.action.notify_landlord`)} 
                                                        />
                                                        <label className="form-check-label small" htmlFor={`notifyL-${index}`}>Notify Landlord</label>
                                                    </div>
                                                </div>
                                            </div>

                                            <hr />
                                            <h6 className="fw-bold small text-muted">Trigger Details</h6>
                                            <div className="row g-3">
                                                <div className="col-md-4">
                                                    <label className="form-label">Trigger Type</label>
                                                    <input 
                                                        type="text" 
                                                        className="form-control form-control-sm"
                                                        {...register(`stages.${index}.trigger.type`)} 
                                                    />
                                                </div>
                                                <div className="col-md-4">
                                                    <label className="form-label">Value (Days)</label>
                                                    <input 
                                                        type="number" 
                                                        className="form-control form-control-sm"
                                                        {...register(`stages.${index}.trigger.value`, { valueAsNumber: true })} 
                                                    />
                                                </div>
                                                <div className="col-md-4">
                                                    <label className="form-label">Result Code</label>
                                                    <input 
                                                        type="number" 
                                                        className="form-control form-control-sm"
                                                        {...register(`stages.${index}.trigger.result_code`, { valueAsNumber: true })} 
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                ))}
                                {fields.length === 0 && <p className="text-center text-muted fst-italic">No stages defined.</p>}
                            </div>

                        </form>
                    </div>
                    
                    <div className="modal-footer">
                        <button type="button" className="btn btn-secondary" onClick={closeModals}>Cancel</button>
                        <button type="submit" form="edit-rule-form" className="btn btn-primary">Save Changes</button>
                    </div>
                </div>
            </div>
        </div>
        {/* <div className="modal-backdrop fade show"></div> */}
          <style jsx>{`
                    .modal.show {
                        background-color: rgba(0, 0, 0, 0.5);
                    }
                `}</style>
    </>
)
}

export default EditRule